import { render } from "./scroll-to-top.vue?vue&type=template&id=518fce4e&scoped=true"
import script from "./scroll-to-top.vue?vue&type=script&lang=js"
export * from "./scroll-to-top.vue?vue&type=script&lang=js"

import "./scroll-to-top.vue?vue&type=style&index=0&id=518fce4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518fce4e"]])

export default __exports__